import { Injectable } from '@angular/core';
import BaseService from '../base/base-service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionStorageService } from './session-storage.service';
import { YeminusApis } from '@cf-v5-workspace/enums';
import LogsEstadosModel from '../models/logs-estados.model';
import CRMEstadosWorkFlowModel from '../models/crm-estados-workflow.model';
import { ConfiguracionHistorialCambioEstadoModel } from '../models/configuracion-historial-cambio-estado.model';
import ResponseModel from '@cf-v5-workspace/utils/models/response.model';


@Injectable({
	providedIn: 'root'
})
export class CrmEstadosService extends BaseService {

	static listadoPreguntas: any[];

	constructor(public http: HttpClient, sessionStorage: SessionStorageService) {
		super(http, sessionStorage);
	}

	/**
	 * Servicio que obtiene los siguientes estados de acuerdo a su flujo de trabajo y el estado actual
	 * @param data
	 * @author Bvelez
	 * @returns
	 */
	obtenerEstadosSiguientes(idWorkFlow: number, idEstadoOrigen: number) : 
		Observable<ResponseModel<Array<CRMEstadosWorkFlowModel>>> 
	{
		return this.consumeApiService('api/crm/estados/obtenerestadossiguientes', {idWorkFlow,idEstadoOrigen}, YeminusApis.GestionTrabajo);
	}

	/**
	 * Agrega un log a logs de estados
	 * @param {any} datos
	 */
	agregarLogEstados(datos: {log: LogsEstadosModel, infoEstadoSiguiente: CRMEstadosWorkFlowModel}): Observable<ResponseModel<Array<LogsEstadosModel>>> {
		return this.consumeService('api/security/logsestados/agregar', datos);
	}

	/**
	 * Método que se encarga de obtener el historico de estados
	 * @author Bvelez
	 */
	obtenerHistoricoEstados(datos: ConfiguracionHistorialCambioEstadoModel): Observable<ResponseModel<Array<LogsEstadosModel>>> {
		return this.consumeService('api/security/logsestados/obtenerhistoricoestados', datos);
	}
}
